import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AutoComplete, Badge, Empty, Input, Spin, Tag } from "antd";
import { useMemo, useState } from "react";
import { useKnowledgeBaseArticles } from "../../hooks/useKnowledgeBaseArticles.js";
import { __ } from "../../utils/i18n.js";
/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */ const KnowledgeBaseSearch = (param)=>{
    let { placeholder, topics, notfound } = param;
    const [busy, setBusy] = useState(false);
    const { loading, knowledgeBaseHits, handleSearchKnowledgeBaseHits } = useKnowledgeBaseArticles(800);
    // Prepare available options for auto complete component
    const options = useMemo(()=>knowledgeBaseHits == null ? void 0 : knowledgeBaseHits.map((param)=>{
            let { toc, introduction, permalink, title, subtitle, content } = param;
            return {
                key: `${title}-${subtitle}-${content}-${permalink}`,
                value: `${title}-${subtitle}-${content}-${permalink}`,
                permalink,
                label: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            dangerouslySetInnerHTML: {
                                __html: title
                            },
                            style: {
                                fontSize: 16,
                                marginBottom: 5
                            }
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            dangerouslySetInnerHTML: {
                                __html: introduction
                            }
                        }),
                        toc.length > 0 && /*#__PURE__*/ _jsxs("div", {
                            style: {
                                lineHeight: 2
                            },
                            children: [
                                __("Table of contents:"),
                                "\xa0",
                                toc.map((t)=>/*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            /*#__PURE__*/ _jsx(Badge, {
                                                dot: t === subtitle,
                                                children: /*#__PURE__*/ _jsx(Tag, {
                                                    style: {
                                                        margin: 0
                                                    },
                                                    children: t
                                                })
                                            }),
                                            "\xa0\xa0"
                                        ]
                                    }, t))
                            ]
                        })
                    ]
                })
            };
        }), [
        knowledgeBaseHits
    ]);
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busy,
        children: /*#__PURE__*/ _jsx(AutoComplete, {
            transitionName: null,
            style: {
                width: "100%"
            },
            options: options,
            notFoundContent: loading ? /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: "center",
                    padding: 10
                },
                children: /*#__PURE__*/ _jsx(Spin, {})
            }) : knowledgeBaseHits && /*#__PURE__*/ _jsx(Empty, {
                description: notfound
            }),
            onSearch: (term)=>handleSearchKnowledgeBaseHits(term, topics),
            onSelect: (_, opts)=>{
                const { permalink } = opts;
                if (permalink) {
                    setBusy(true);
                    window.location.href = permalink;
                }
                return false;
            },
            children: /*#__PURE__*/ _jsx(Input, {
                size: "large",
                placeholder: placeholder
            })
        })
    });
};
export { KnowledgeBaseSearch };
